import React from "react";
import {QuickGuide, QuickGuideProps, QuickGuideStates} from "../QuickGuide";
import {RawProvider} from "../../../../res/RawProvider";

export class ShowMapFromReservationDetailQuickGuide extends React.Component<QuickGuideProps, QuickGuideStates> {

    render() {
        return <div>
            <QuickGuide
                steps={RawProvider.quickGuide.showMapReservationDetail}/>;
        </div>
    }

}
